import React, { useMemo, useState } from 'react';
import Style from '../style';
import { scrollTo } from 'datastake-daf/src/helpers/GoToSelect';
import SupplyChainDetails from '../../sca-dds-kyc-widgets/supply-chain-details';
import SubjectDetails from '../../sca-dds-kyc-widgets/subject-details';
import CounterpartyAssessment from '../../sca-dds-kyc-widgets/counterparty-assessment';
import InformationAvailabillity from '../../sca-dds-kyc-widgets/information-availability';
import ProgressPerTime from '../../sca-dds-kyc-widgets/progress-per-time';
import ProgressPerSection from '../../sca-dds-kyc-widgets/progress-per-section';
import SourceContributions from '../../sca-dds-kyc-widgets/source-contributions';
import BeneficialOwnership from '../../sca-dds-kyc-widgets/beneficial-ownership';
import { ReactFlowProvider } from 'react-flow-renderer';
// import DueDilligenceOverview from '../../sca-dds-kyc-widgets/due-dilligence-overview';
import TradeRelationship from '../../sca-dds-kyc-widgets/trade-relationship';
import TableComponents from '../../sca-dds-kyc-widgets/table-components';
import DetailsWidget from '../../components/details-widget';
import { useTranslation } from 'react-i18next';
import AssessmentPerformance from '../../sca-dds-kyc-widgets/assessment-performance';
import ComplianceGaps from '../../sca-dds-kyc-widgets/compliance-gaps';
import InfoWidgetsSections from '../../components/info-widgets-section';
import { Button } from 'antd';
import { CustomIcon, GoToSelect } from 'datastake-daf/dist/components';
import Activities from '../../sca-dds-kyc-widgets/activities';
import { selectOptions } from './config';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const emptyArray = [];

// const namespacesWithDdsOverview = [
//   'scp',
// ];

export default function SCALayout({
  namespace = null,
  data = null,
  sources = {},
  activeSources = [],
  isOwnData = false,
  getRedirectLink = () => { },
  // other = {},
  mode = 'app',
  isSingleSource = false,
  redirectToView = () => { },
  setVisibleSettings = () => { },
  selectedSource = null,
  getOption = () => { },
  hasDDSystems = false,
  sidebarCollapsed,
  loading,
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(undefined);
  const [filterKey, setFilterKey] = useState(null);

  const [changeKey, setChangeKey] = useState(null);

  const counterpartyRating = useMemo(() => {
    return {
      assessment: data?.kycScore,
      counterpartyReview: data?.counterpartyScore,
      riskReadiness: data?.riskRediness,
      documentation: data?.documentation,
      challanges: data?.checksReview?.active || 0,
    };
  }, [data]);

  const [tradeData, setTradeData] = useState({
    mineSites: [],
    suppliers: [],
    customers: [],
  });

  const _onChange = (val) => {
    const _cont = document.querySelector('.view-content');
    setValue(val);

    if (_cont) {
      const diff = isSingleSource ? 275 : 220;

      switch (val) {
        case '1c':
        case '2c':
        case '3c':
          const _el1 = document.getElementById('1c');
          scrollTo({ _el: _el1, _cont, diff });
          break;
        case '4c':
          const _el2 = document.getElementById('4c');
          scrollTo({ _el: _el2, _cont, diff });
          break;
        case '5c':
          const _el3 = document.getElementById('5c');
          scrollTo({ _el: _el3, _cont, diff });
          break;
        case '6c':
        case '7c':
          const _el4 = document.getElementById('6c');
          scrollTo({ _el: _el4, _cont, diff });
          break;
        case '8c':
        case '9c':
        case '10c':
        case '11c':
          const _el5 = document.getElementById('8c');
          scrollTo({ _el: _el5, _cont, diff });
          break;
        case '12c':
          const _el6 = document.getElementById('12c');
          scrollTo({ _el: _el6, _cont, diff });
          break;
        default:
      }

      setFilterKey(val);
    }
  };

  return (
    <Style
      className={formatClassname(['main-project-container',
        !isOwnData ? mode === 'app' ?
          (sidebarCollapsed ? 'not-collapsed' : 'collapsed')
          : (sidebarCollapsed ? 'own-data-not-collapsed' : 'own-data-collapsed') : ''
      ])}
    >
      <div className="go-select-cont">
        <GoToSelect
          mainClassName=".view-content"
          className="full mb-0"
          onChange={_onChange}
          options={selectOptions}
          setValue={setValue}
          value={value}
        >
          {!(isOwnData || isSingleSource) ? (
            <Button
              icon={(
                <CustomIcon name="Filters" width={16} height={16} />
              )}
              onClick={() => setVisibleSettings(true)}
            >
              {t('Data Settings')}
            </Button>
          ) : null}
        </GoToSelect>
      </div>

      <div className="sections-cont">
        <section>
          <div style={{ flex: 2 }}>
            <CounterpartyAssessment
              data={counterpartyRating?.counterpartyReview}
              loading={loading}
            />
          </div>
          <div style={{ flex: 1 }}>
            <DetailsWidget
              label={t("KYC Score")}
              tooltip={{
                title: t('KYC Socre'),
                body: t('The KYC score is the result of automated checks, based on structured information available on the counterparty.'),
              }}
              value={
                typeof counterpartyRating?.assessment === 'number' ?
                  Number(counterpartyRating?.assessment).toFixed(2)
                  : '-'
              }
              loading={loading}
              onClick={() => {
                setChangeKey('checks');
                const _cont = document.querySelector('.view-content');
                const _el = document.getElementById('8c');
                scrollTo({ _el, _cont });
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <DetailsWidget
              label={t("Documentation")}
              loading={loading}
              tooltip={{
                title: t('Documentation Availability'),
                body: [
                  t('Share of available documents among those recommended to investigate the counterparty.'),
                  t('A counterparty risk management strategy can include an improvement in terms of documentation availability.'),
                ],
              }}
              value={counterpartyRating?.documentation}
              type="percentage"
              link="#sca-table-components"
              onClick={() => {
                setChangeKey('documentationChecks');
                const _cont = document.querySelector('.view-content');
                const _el = document.getElementById('8c');
                scrollTo({ _el, _cont });
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <DetailsWidget
              loading={loading}
              label={t("Risk Readiness")}
              type="percentage"
              value={counterpartyRating?.riskReadiness}
              tooltip={{
                title: t('Risk Readiness'),
                body: [
                  t("Risk readiness is based on the counterparty's reporting of due diligence systems (in accordance with OECD Step 1). It may only be assessed if the counterparty itself is a source of information in Datastake."),
                  t('Risk readiness means risk management systems are in place and documented.'),

                ],
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <DetailsWidget
              label={t("Active Challenges")}
              value={counterpartyRating?.challanges}
              loading={loading}
              link="#sca-table-components"
              onClick={() => {
                setChangeKey('challenges');
                const _cont = document.querySelector('.view-content');
                const _el = document.getElementById('8c');
                scrollTo({ _el, _cont });
              }}
              tooltip={{
                title: t('Active Challenges'),
                body: [
                  t('Total number of compliance gaps and open recommendations related to the counterparty.'),
                  t('A counterparty risk management strategy can consist in the reduction in the number or severity of active challenges over time.'),
                ],
              }}
            />
          </div>
        </section>
        <section>
          <section style={{ flex: 2 }} className="flex">
            <SubjectDetails
              sources={activeSources.length}
              isOwnData={isOwnData}
              loading={loading}
              data={data?.subjectDetails}
              namespace={namespace}
              getOption={getOption}
            />
          </section>
          <section style={{ flex: 1 }} className="flex-column">
            <SupplyChainDetails
              data={data?.supplyChainDetails}
              namespace={namespace}
              getOption={getOption}
              loading={loading}
              tradeData={tradeData}
            />
            <Activities
              data={data?.supplyChainDetails}
              loading={loading}
              getOption={getOption}
            />
          </section>
        </section>
        <section id="1c" style={{ flexWrap: 'nowrap' }} className="overflow-section">
          <section style={{ flex: 1 }}>
            <InformationAvailabillity
              subjectName={data?.subjectDetails?.subjectName}
              data={data?.informationAvailability}
              isOwnData={isOwnData}
              isSingleSource={isSingleSource}
              loading={loading}
            />
          </section>
          <section style={{ flex: 2.15 }}>
            {(isSingleSource) ? (
              <ProgressPerSection
                data={data?.progressPerSection}
                getOption={getOption}
                sidebarCollapsed={sidebarCollapsed}
                loading={loading}
              />
            ) : (
              <SourceContributions
                loading={loading}
                data={data?.sourceContributors}
                getRedirectLink={getRedirectLink}
              />
            )}
            <ProgressPerTime
              isConsolidated={(isSingleSource || selectedSource)
                ? false : activeSources.length > 1}
              data={data?.progressPerTime}
              loading={loading}
            />
          </section>
        </section>
        {/* {namespacesWithDdsOverview.includes(namespace) && hasDDSystems && !isOwnData && (
          <DueDilligenceOverview
            data={data?.dds}
            hasDDSystems={hasDDSystems}
            isOwnData={isOwnData}
          /> 
        )} */}
        <section id="4c">
          <ReactFlowProvider>
            <BeneficialOwnership
              redirectToView={redirectToView}
              data={{ ...(data?.beneficialOwnership || {}), sources }}
              getOption={getOption}
              mode={mode}
              isSingleSource={isSingleSource}
              selectedSource={selectedSource}
              loading={loading}
            />
          </ReactFlowProvider>
        </section>
        <InfoWidgetsSections
          data={data?.checksReview}
          sidebarCollapsed={sidebarCollapsed}
          loading={loading}
        />
        <section className="nowrap" id="6c">
          <AssessmentPerformance
            isSingleSource={isSingleSource}
            data={data?.performanceAssessment}
            loading={loading}
          />
          <ComplianceGaps
            data={data?.complianceGaps}
            sidebarCollapsed={sidebarCollapsed}
            loading={loading}
          />
        </section>
        <section id="8c">
          <TableComponents
            filterKey={filterKey}
            setFilterKey={setFilterKey}
            data={data?.tableComponents}
            counterpartyRating={data?.counterpartyRating}
            changeKey={changeKey}
            setChangeKey={setChangeKey}
            loading={loading}
            sidebarCollapsed={sidebarCollapsed}
          />
        </section>
        <section id="12c">
          <ReactFlowProvider>
            <TradeRelationship
              mode={mode}
              isSingleSource={isSingleSource}
              data={data?.tradeRelationships || emptyArray}
              featuredData={sources?.featuredData || emptyArray}
              informationSources={sources?.otherInformationSources || emptyArray}
              supplyChainActors={sources?.supplyChainActor || emptyArray}
              activeSources={activeSources || emptyArray}
              getRedirectLink={getRedirectLink}
              setTradeData={setTradeData}
              loading={loading}
            />
          </ReactFlowProvider>
        </section>
      </div>
    </Style >
  );
}
